export const getStorage = () => window.sessionStorage;

export const clearStorage = (name: string) => getStorage().removeItem(name);
